<template>
  <div>
    <div class="horizontal-item p-3">
      <div class="d-md-flex justify-content-between">
        <div class="d-md-flex">
          <div class="position-relative">
            <small-carousel
              :images="images"
              :show-indicators="false"
              height="160px"
            ></small-carousel>
            <div class="circle-area" v-if="isOffertaSpeciale">
              <p>Offerta Speciale</p>
            </div>
          </div>
          <div class="position-relative">
            <div>
              <div class="type-info" :class="isHighlight ? 'bg-primary' : ''">
                <span>{{ label }}</span>
              </div>
              <div class="d-flex">
                <div class="date-info">
                  <h1 class="m-0">{{ day }}</h1>
                  <h5 class="text-uppercase m-0">{{ month }}</h5>
                </div>
                <div class="item-info">
                  <h3>{{ name }}</h3>
                </div>
              </div>
            </div>
            <div>
              <div class="detail-info d-md-flex justify-content-around mb-2">
                <div>
                  <span class="notti nowrap">
                    <b>{{ this.nights }}</b> notti -
                    <b>{{ this.days }}</b> giorni
                  </span>
                </div>
                <div v-if="isPartenzaGarantita">
                  <span v-if="isPartenzaGarantita" class="partenza-garantita"
                    >partenza garantita</span
                  >
                </div>
              </div>
              <div
                class="mb-2 mb-md-0 dates-info d-md-flex justify-content-around"
              >
                <div class="position-relative" v-if="isAltreDate">
                  <a
                    href="javascript:void(0)"
                    class="dates text-primary"
                    @click="showAltreDate = !showAltreDate"
                    >altre date disponibili</a
                  >
                  <div
                    @mouseleave="showAltreDate = false"
                    @click="showAltreDate = false"
                    v-if="showAltreDate"
                    class="position-absolute p-1 border rounded bg-white text-center"
                    style="z-index: 10; max-height: 130px; overflow: auto"
                  >
                    <button
                      v-for="(item, index) in departureFutureDates"
                      :key="index"
                      @click="onOpenDetailWithDate(item)"
                      style="width: 45px"
                      class="rounded-0 m-1 px-1 btn btn-outline-primary btn-sm nowrap"
                    >
                      {{ formatDate(item) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="position-relative text-center pt-2 pt-md-0">
            <h6 class="text-uppercase">a partire da</h6>
            <h1 class="currency">{{ price }} &euro;</h1>
            <small
              v-show="isVoloRequested"
              class="w-100 text-center position-absolute text-uppercase mb-1"
              style="bottom: -20px; left: 0"
              >volo incluso</small
            >
          </div>
          <div>
            <button
              id="scegliTour"
              class="btn btn-primary px-5"
              @click="onOpenDetail"
            >
              scegli
            </button>
          </div>
        </div>
      </div>
    </div>
    <ModalTourDetail
      :value="value"
      :is-home-page="true"
      ref="modalTourDetail"
      @select="onSelect"
      :is-camere-requested="isHomePage"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  CONFIG_DATE_FORMAT,
  formatMoney,
  middleDateFormatter,
  smallerDateFormatter,
  toDateFromServer,
} from "../../../../utils/formatter";
import { isSameDate, tourName } from "../../../../utils/helper";
import ModalTourDetail from "../../pages/tour-accompagnati/modals/ModalTourDetail";
import SmallCarousel from "../SmallCarousel";
import AnalyticEvents from "../../../common/AnalyticEvents";
import ConfigUtils from "../../../utils/ConfigUtils";

export default {
  name: "HorizontalItemTour",
  mixins: [AnalyticEvents, ConfigUtils],
  components: { SmallCarousel, ModalTourDetail },
  props: {
    aereoporti: Array,
    value: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    isHomePage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      aereoporto: null,
      showAltreDate: false,
    };
  },
  computed: {
    config() {
      return this.value.config;
    },
    label() {
      return this.config.label ? this.config.label : "N/D";
    },
    isHighlight() {
      return this.config.isHighlight ? this.config.isHighlight : false;
    },
    isOffertaSpeciale() {
      const search = this.getSearch();
      if (search.partenza === null) {
        return this.config && this.config.datesOffertaSpeciale.length > 0;
      }
      return (
        this.config &&
        this.config.datesOffertaSpeciale.some((item) => {
          const date = this.$moment(item).toDate();
          return isSameDate(date, search.partenza);
        })
      );
    },
    isPartenzaGarantita() {
      const search = this.getSearch();
      if (search.partenza === null) {
        return this.config && this.config.datesPartenzaGarantita.length > 0;
      }
      return (
        this.config &&
        this.config.datesPartenzaGarantita.some((item) => {
          const date = this.$moment(item, CONFIG_DATE_FORMAT).toDate();
          return isSameDate(date, search.partenza);
        })
      );
    },
    departuresDatePrice() {
      return this.element.departuresDatePrice;
    },
    price() {
      const price = this.departuresDatePrice
        .map((item) => item.price.importo)
        .reduce((totale, current) => {
          return Math.min(totale, current);
        });
      return formatMoney(price);
    },
    isAltreDate() {
      return this.departuresDatePrice.length > 1;
    },
    detail() {
      return this.value.detailResponse.detail;
    },
    isVoloRequested() {
      return this.detail.flightIncluded;
    },
    escort() {
      return this.detail.escort;
    },
    productId() {
      return this.detail.productID;
    },
    element() {
      return this.value.element;
    },
    days() {
      return this.detail.days;
    },
    nights() {
      return this.detail.nights;
    },
    name() {
      return tourName(this.detail.name);
    },
    departureFutureDates() {
      const dates = this.element.departuresDatePrice.map((item) => {
        return toDateFromServer(item.date.date);
      });
      const partenza = this.$store.getters.isGiornoSuccessivoObbligatorio
        ? this.$moment(this.getSearch().partenza).add(1, "days").toDate()
        : this.getSearch().partenza;
      return partenza == null
        ? dates
        : dates.filter((date) => date.getTime() >= partenza.getTime());
    },
    departureDate() {
      return this.departureFutureDates[0];
    },
    date() {
      return middleDateFormatter(this.departureDate);
    },
    day() {
      return this.$moment(this.departureDate).format("DD");
    },
    month() {
      return this.$moment(this.departureDate).format("MMM");
    },
    images() {
      return this.detail.imagesUrl;
    },
    bgImageStyle() {
      if (!this.images) return "";
      return `background-image: url(${this.images[0]})`;
    },
  },
  methods: {
    ...mapGetters(["getSearch", "getTours"]),
    ...mapActions(["addSearch"]),
    onOpenDetailWithDate(date) {
      this.trackHomeOfferteSpecialiAltreDate();
      this.$refs.modalTourDetail.open(date);
    },
    onOpenDetail() {
      this.trackHomeOfferteSpecialiScegli();
      this.$refs.modalTourDetail.open(this.departureDate);
    },
    onSelect(tour) {
      this.$emit("select", tour);
    },
    formatDate(date) {
      return smallerDateFormatter(date);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/tours/HorizontalItemTour.vue